export const themes = [
    {
        "title": "eSports",
        "image": require("assets/img/themes/esports.jpg"),
        "id": 313
    },
    {
        "title": "High-end Android Smartphones",
        "image": require("assets/img/themes/android.jpg"),
        "id": 315
    },
    {
        "title": "iPhone",
        "image": require("assets/img/themes/iphone.jpg"),
        "id": 316
    },
    {
        "title": "3D Sensing",
        "image": require("assets/img/themes/3dsensing.jpg"),
        "id": 317,
        "subthemes": [
            {
                "title": "3D Sensing - Android",
                "subthemes": [
                    {
                        "title": "Foundry (3D Sensing for VCSEL) - Android",
                        "stocks": [
                            {
                                "id": "17424",
                                "ticker": "3105 TT",
                                "title": "Win Semi"
                            },
                            {
                                "id": "22881",
                                "ticker": "8086 TT",
                                "title": "AWSC"
                            }
                        ]
                    },
                    {
                        "title": "IDM (3D Sensing for VCSEL) - Android",
                        "stocks": [
                            {
                                "id": "40236",
                                "ticker": "LITE US",
                                "title": "Lumentum Holdings Inc"
                            },
                            {
                                "id": "78",
                                "ticker": "FNSR US",
                                "title": "Finisar Corporation"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "3D Sensing - iPhone",
                "subthemes": [
                    {
                        "title": "Foundry (3D Sensing for VCSEL) - iPhone",
                        "stocks": [
                            {
                                "id": "17424",
                                "ticker": "3105 TT",
                                "title": "Win Semi"
                            }
                        ]
                    },
                    {
                        "title": "CMOS Sensor for 3D Sensing - iPhone",
                        "stocks": [
                            {
                                "id": "2946",
                                "ticker": "6758 JP",
                                "title": "Sony Corporation"
                            },
                            {
                                "id": "2738",
                                "ticker": "STM FP",
                                "title": "STMicroelectronics NV"
                            }
                        ]
                    }
                ]
            }
        ],
    },
    {
        "title": "5G",
        "image": require("assets/img/themes/5g.jpg"),
        "id": 277,
        "subthemes": [
            {
                "title": "5G Key Materials",
                "subthemes": [
                    {
                        "title": "Epiwafer merchant",
                        "stocks": [
                            {
                                "id": 38000,
                                "ticker": "IQE LN",
                                "title": "IQE plc"
                            },
                            {
                                "id": 15931,
                                "ticker": "2455 TT",
                                "title": "Visual Photonics Epitaxy Co Ltd"
                            },
                            {
                                "id": 19095,
                                "ticker": "4971 TT",
                                "title": "IntelliEPI Inc (Cayman)"
                            }
                        ]
                    },
                    {
                        "title": "IC Substrate/PCB",
                        "stocks": [
                            {
                                "id": 19080,
                                "ticker": "4958 TT",
                                "title": "Zhen Ding Technology Holding Limited"
                            },
                            {
                                "id": 4355,
                                "ticker": "TTMI US",
                                "title": "TTM Technologies Inc"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Optical modules",
                "stocks": [
                    {
                        "id": 19106,
                        "ticker": "4977 TT",
                        "title": "PCL Technologies Inc"
                    },
                    {
                        "id": 23576,
                        "ticker": "877 HK",
                        "title": "O-Net Technologies (Group) Ltd"
                    }
                ]
            }
        ],
    },
    {
        "title": "Semis by Different Application",
        "image": require("assets/img/themes/semiconductors.jpg"),
        "id": 318
    },
    {
        "title": "AI & Big Data",
        "image": require("assets/img/themes/ai.jpg"),
        "subthemes": [
            {
                "title": "AI & Big Data",
                "subthemes": [
                    {
                        "title": "Data Center",
                        "stocks": [
                            {
                                "id": "3403",
                                "ticker": "NVDA US",
                                "title": "NVIDIA Corporation"
                            },
                            {
                                "id": "876",
                                "ticker": "AMD US",
                                "title": "Advanced Micro Devices Inc"
                            }
                        ]
                    },
                    {
                        "title": "High Speed interface",
                        "stocks": [
                            {
                                "id": "19087",
                                "ticker": "4966 TT",
                                "title": "Parade Technologies Ltd"
                            },
                            {
                                "id": "19311",
                                "ticker": "5269 TT",
                                "title": "ASMedia"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Smart speakers",
                "subthemes": [
                    {
                        "title": "Smart speaker Developers",
                        "stocks": [
                            {
                                "id": "27347",
                                "ticker": "BABA US",
                                "title": "Alibaba"
                            },
                            {
                                "id": "591",
                                "ticker": "AMZN US",
                                "title": "Amazon"
                            }
                        ]
                    },
                    {
                        "title": "Smart speakers/Headsets OEMs",
                        "stocks": [
                            {
                                "id": "15908",
                                "ticker": "2439 TT",
                                "title": "Merry"
                            },
                            {
                                "id": "11635",
                                "ticker": "002241 CH",
                                "title": "Goertek"
                            }
                        ]
                    }
                ]
            }
        ],
        "id": 319
    },
    {
        "title": "Tech by End Markets",
        "image": require("assets/img/themes/tech_by_end_market.jpg"),
        "id": 320
    },
    {
        "title": "Online Gaming",
        "image": require("assets/img/themes/game.jpg"),
        "id": 0
    },
    {
        "title": "Industrial Automation",
        "image": require("assets/img/themes/industrial_automation.jpg"),
        "subthemes": [
            {
                "title": "Control System",
                "subthemes": [
                    {
                        "title": "MES",
                        "stocks": [
                            {
                                "id": "1803",
                                "ticker": "ROK US",
                                "title": "Rockwell"
                            },
                            {
                                "id": "4054",
                                "ticker": "SIE DE",
                                "title": "Siemens"
                            }
                        ]
                    },
                    {
                        "title": "DCS",
                        "stocks": [
                            {
                                "id": "1226",
                                "ticker": "EMR US",
                                "title": "Emerson"
                            },
                            {
                                "id": "36623",
                                "ticker": "HOLI US",
                                "title": "Hollysys"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Control Instrument",
                "subthemes": [
                    {
                        "title": "CNC",
                        "stocks": [
                            {
                                "id": "22110",
                                "ticker": "6954 JP",
                                "title": "Fanuc"
                            },
                            {
                                "id": "21838",
                                "ticker": "6645 JP",
                                "title": "Omron"
                            }
                        ]
                    },
                    {
                        "title": "PLC/IPC/PAC",
                        "stocks": [
                            {
                                "id": "207",
                                "ticker": "GE US",
                                "title": "GE"
                            },
                            {
                                "id": "54",
                                "ticker": "8058 JP",
                                "title": "Yaskawa"
                            }
                        ]
                    }
                ]
            }
        ],
        "id": 328
    },
    {
        "title": "Internet of Things",
        "image": require("assets/img/themes/internetofthings.jpg"),
        "id": 292
    },
    {
        "title": "EV",
        "image": require("assets/img/themes/ev.jpg"),
        "id": 265
    },
    {
        "title": "ADAS",
        "image": require("assets/img/themes/adas.jpg"),
        "id": 274
    },
    {
        "title": "Global Security",
        "image": require("assets/img/themes/globalsecurity.jpg"),
        "id": 0
    },
    {
        "title": "Defense",
        "image": require("assets/img/themes/defense.jpg"),
        "id": 321
    },
    {
        "title": "Cybersecurity",
        "image": require("assets/img/themes/cybersecurity.jpg"),
        "id": 284
    },
    {
        "title": "E-commerce",
        "image": require("assets/img/themes/ecommerce.jpg"),
        "id": 322
    },
    {
        "title": "Fintech",
        "image": require("assets/img/themes/fintech.jpg"),
        "subthemes": [
            {
                "title": "Mobile Payments",
                "stocks": [
                    {
                        "id": "691",
                        "ticker": "AAPL US",
                        "title": "AAPL US"
                    },
                    {
                        "id": "443",
                        "ticker": "GOOGLE US",
                        "title": "GOOGLE US"
                    }
                ]
            },
            {
                "title": "P2P Lending",
                "stocks": [
                    {
                        "id": "92",
                        "ticker": "LC US",
                        "title": "LC US"
                    },
                    {
                        "id": "54945",
                        "ticker": "YRD US",
                        "title": "YRD US"
                    }
                ]
            }
        ],
        "id": 325
    },
    {
        "title": "Education",
        "image": require("assets/img/themes/education.jpg"),
        "id": 323
    },
    {
        "title": "Environmental Protection",
        "image": require("assets/img/themes/environment_protection.jpg"),
        "id": 324
    },
    {
        "title": "Consumption Upgrade",
        "image": require("assets/img/themes/consumption_upgrade.jpg"),
        "id": 0
    },
    {
        "title": "Lifestyle",
        "image": require("assets/img/themes/lifestyle.jpg"),
        "id": 329
    },
    {
        "title": "Food And Beverage",
        "image": require("assets/img/themes/foodandbeverage.jpg"),
        "id": 0
    },
    {
        "title": "Food Safety",
        "image": require("assets/img/themes/foodsafety.png"),
        "id": 326
    },
    {
        "title": "Sportswear",
        "image": require("assets/img/themes/sportwear.jpg"),
        "id": 334
    },
    {
        "title": "Travel And Leisure",
        "image": require("assets/img/themes/travelleisure.jpg"),
        "id": 335
    },
    {
        "title": "Global Luxury",
        "image": require("assets/img/themes/global_luxury.jpg"),
        "id": 327
    },
    {
        "title": "Personal Care",
        "image": require("assets/img/themes/personal_care.jpg"),
        "id": 331
    },
    {
        "title": "Gold",
        "image": require("assets/img/themes/gold.jpg"),
        "id": 133
    },
    {
        "title": "Health Care",
        "image": require("assets/img/themes/healthcare.jpg"),
        "id": 227
    },
    {
        "title": "Insurance",
        "image": require("assets/img/themes/insurance.jpg"),
        "id": 215
    },
    {
        "title": "Shared Economy",
        "image": require("assets/img/themes/shared_economy.jpg"),
        "id": 332
    },
    {
        "title": "Shared Economy-Autos",
        "image": require("assets/img/themes/shared_economy_auto.jpg"),
        "id": 333
    },
    {
        "title": "Mobile Payments",
        "image": require("assets/img/themes/mobile_payment.jpg"),
        "id": 330
    },
    {
        "title": "Consumer By End Market",
        "image": require("assets/img/themes/consumer_end_market.jpg"),
        "subthemes": [
            {
                "title": "Apparel & Footwear",
                "stocks": [
                    {
                        "id": "17636",
                        "ticker": "330 HK",
                        "title": "Esprit"
                    },
                    {
                        "id": "4846",
                        "ticker": "709 HK",
                        "title": "Giordano"
                    },
                    {
                        "id": "2426",
                        "ticker": "GES US",
                        "title": "Guess"
                    },
                    {
                        "id": "2326",
                        "ticker": "AEO US",
                        "title": "American Eagle"
                    },
                    {
                        "id": "2901",
                        "ticker": "ANF US",
                        "title": "Abercrombie & Fitch "
                    }
                ]
            },
            {
                "title": "Food Retailers",
                "stocks": [
                    {
                        "id": "118",
                        "ticker": "6808 HK",
                        "title": "Sun Art"
                    },
                    {
                        "id": "24150",
                        "ticker": "980 HK",
                        "title": "Lianhua"
                    },
                    {
                        "id": "2025",
                        "ticker": "WMT US",
                        "title": "Wal-Mart Stores"
                    },
                    {
                        "id": "113",
                        "ticker": "WOW AU",
                        "title": "Woolworths Ltd"
                    },
                    {
                        "id": "6302",
                        "ticker": "MRW LN",
                        "title": "WM Morrison Supermarkets"
                    }
                ]
            },
            {
                "title": "Retail Channel",
                "stocks": [
                    {
                        "id": "1651",
                        "ticker": "JWN US",
                        "title": "Nordstrom"
                    },
                    {
                        "id": "1486",
                        "ticker": "KSS US",
                        "title": "Kohl's"
                    },
                    {
                        "id": "1264",
                        "ticker": "M US",
                        "title": "Macy's"
                    },
                    {
                        "id": "1188",
                        "ticker": "DDS US",
                        "title": "Dillard's"
                    },
                    {
                        "id": "15155",
                        "ticker": "1997 HK",
                        "title": "The Wharf"
                    },
                    {
                        "id": "5623",
                        "ticker": "19 HK",
                        "title": "Swire Pacific"
                    }
                ]
            },
            {
                "title": "Cosmetics & Skin Care",
                "stocks": [
                    {
                        "id": "14846",
                        "ticker": "178 HK",
                        "title": "Sa Sa"
                    },
                    {
                        "id": "15084",
                        "ticker": "1944 JP",
                        "title": "Shiseido"
                    },
                    {
                        "id": "2642",
                        "ticker": "EL US",
                        "title": "Estee Lauder"
                    },
                    {
                        "id": "30631",
                        "ticker": "COTY US",
                        "title": "Coty"
                    },
                    {
                        "id": "959",
                        "ticker": "AVP US",
                        "title": "Avon"
                    },
                    {
                        "id": "27749",
                        "ticker": "BEI GR",
                        "title": "Beiersdorf"
                    }
                ]
            },
            {
                "title": "Luxury",
                "stocks": [
                    {
                        "id": "4349",
                        "ticker": "TPR US",
                        "title": "Tapastry"
                    },
                    {
                        "id": "35490",
                        "ticker": "GOOS US",
                        "title": "Canada Goose"
                    },
                    {
                        "id": "159",
                        "ticker": "MONC IM",
                        "title": "Moncler"
                    },
                    {
                        "id": "160",
                        "ticker": "KORS US",
                        "title": "Michael Kors"
                    },
                    {
                        "id": "140720",
                        "ticker": "SFRSW",
                        "title": "Richmonte"
                    },
                    {
                        "id": "2738",
                        "ticker": "RMS FP",
                        "title": "Hermes Intl"
                    }
                ]
            }
        ],
        "id": 0
    }
]